export const name = 'assetsManagementsDirective';
export default function assetsManagementsDirective() {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let directive = {
    restrict: 'E',
    template: require('./assets-management-directive.html'),
    scope:{
      fileSelectedCallback: "=fileSelectedCallback",
      resetSelection: "=resetSelection",
      isDialog: "=isDialog",
      numOfElementsOut: "=numOfElementsOut"
    },
    controller: assetsManagementsDirectiveController,
    controllerAs: 'vm',
    bindToController: true,
  };

  return directive;
}

function assetsManagementsDirectiveController(assetsLibService, $log, $mdDialog, $q, $scope, $translate, closeDialogFromOutsideHelperFactory, pusherChannel, listManagementFactory) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let vm = this;

  vm.searchText = '';
  vm.initializing = true;
  vm.closeUploadDialog = closeDialogFromOutsideHelperFactory.createCloseDialogFromOutsideHelperObject();
  vm.filesAmountLimit = 15;
  let fileSizeLimit = 10737418240;//10GB//15032385536; 14GB //21474836480;//20GB //10737418240;

  //Self execute init func
  (function init() {
    vm.listMonitoringUtility = listManagementFactory.getMonitoringListService();

    let listInitParams = {
      listName : 'ComposerAssetLibrariesList',
      fetchListByPageFunc : getAssetLibsByPage,
      getChannelNameFunc : pusherChannel.getChannelName,
      entryUUIDFieldName : "assetsLibUUID",
      entryIdentificationFieldName : "assetsLibId",
      entryNameFieldName : "name",
      listOfDateAttributesToFormat : ['createdDate', 'expirationDate'],
      placeToAddNewElementToList: listManagementFactory.addNewToBeginningOfList,
      isMultiSelect: vm.isDialog === false,
      pagination : {
        limit:15,
        page:1,
        elementsPerPageOptions:[15,20,30]
      },
      events : {
        addedEntry : "ASSETS_LIST_ENTRY_ADDED",
        deletedEntry : "ASSETS_LIST_ENTRY_DELETED",
        changedEntry : "ASSETS_LIST_ENTRY_CHANGED"
      },
      callbacks : {
        onAddedEntry : onAddAssetLib,
        onDeletedEntry : null,
        onChangedEntry : onAssetLibChange,
        onFileSelect : vm.fileSelectedCallback,
        actionBeforeDeletion : null,
        actionBeforeAddedChanged : null,
        actionBeforeChangedOnOldData : null
      }
    };

    function getAssetLibsByPage(page, pageSize, filter, tag, isInitializing, isLoadingRequired = true){
      let defer = $q.defer();
      assetsLibService.getAssetLibsByPage(page, pageSize, filter, tag, isInitializing, isLoadingRequired).then(listOfAssetLibs => {
        $translate.onReady(function() {
          listOfAssetLibs.listOfElements.forEach(assetLib => {
            assetLib.statusForDisplay = $translate.instant("imposer.composer-main.Composer_Status_" + assetLib.status);
          });
        });
        defer.resolve(listOfAssetLibs);
      },error => defer.reject(error));
      return defer.promise;
    }

    vm.listMonitoringUtility.initialize(listInitParams).then(listOfAssetLibs => {
        vm.initializing = false;
        if(vm.numOfElementsOut){
          vm.numOfElementsOut(vm.listMonitoringUtility.totalNumberOfElements);
        }
    });

    $translate.onReady(function() {
      vm.filesAmountLimitErrorMessage = $translate.instant('imposer.composer-main.assets_management_files_amount_limit', [vm.filesAmountLimit]);
    });
  })();

  $scope.$watch('vm.resetSelection', function (editingForm) {
    vm.listMonitoringUtility.selected = [];
  });

  vm.delete = function(event){
    let listOfAssetsLibraries = vm.listMonitoringUtility.selected.map(curr => curr.assetsLibUUID);

    let functionName = 'assetsManagementsDirective.delete';
    $log.info(angular.toJson({action: 'function called', functionName: functionName}));
    let libName = '';
    if (vm.listMonitoringUtility.selected.length === 0) {
      return;
    }else if(vm.listMonitoringUtility.selected.length === 1){
      libName = vm.listMonitoringUtility.selected[0].name;
    }

    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: true,
      template: require('./../delete-assets-libraries/library-delete.html'),
      controller: 'libraryDeleteController',
      bindToController: true,
      controllerAs: 'libraryDeleteController',
      locals: {listOfAssetsLibraries: listOfAssetsLibraries, libName: libName}
    }).then(function (data) {
      $log.info(angular.toJson({action: 'dialog closed successfully', functionName: functionName}));
    });

    $log.info(angular.toJson({action: 'function return', functionName: functionName}));
  };

  vm.filterList = function(assetLib){
    if(vm.isDialog){
      return assetLib.status === 'Ready';
    }else{
      return true;
    }
  };

  function deleteEntity(assetsLibUUID) {
    let functionName='assetsManagementsDirective.deleteEntity';
    $log.info(angular.toJson({action:'function called', functionName:functionName}));

    assetsLibService.deleteAssetLibraries([assetsLibUUID]).then(function () {
      $log.info(angular.toJson({action:'Asset libraries deleted successfully', functionName:functionName}));
    }, function(status) {
      $log.info(angular.toJson({action:'error deleting asset libraries', functionName:functionName}));
    });
    $log.info(angular.toJson({action:'function return', functionName:functionName}));
  }

  vm.closeUploadDialog = closeDialogFromOutsideHelperFactory.createCloseDialogFromOutsideHelperObject();

  vm.upload = function(event){
    openUploadDialog(event);
  };

  vm.isReadyAssetsExist = function(){
    return vm.listMonitoringUtility.theList.filter(curr => curr.status === 'Ready').length > 0;
  };

  function openUploadDialog($event){
    let functionName='TemplateListController.openUploadDialog';
    $log.info(angular.toJson({action:'function called', functionName:functionName}));

    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: $event,
      clickOutsideToClose: false,
      escapeToClose: true,
      template: require('@printos/imposer-ui/src/components/templates/file-upload-dialog/fileUploadDialog.html'),
      controller: 'fileUploadDialogController',
      bindToController: true,
      controllerAs: 'vm',
      locals: {
        title: 'imposer.composer-main.assets_management_upload_dialog',
        fileType: '.zip',
        fileTypeDisplay: 'ZIP',
        uploadMethod: assetsLibService.uploadFile,
        mimeType: null,
        fileSizeLimit: fileSizeLimit,
        additionalInfo: 'imposer.composer-main.assets_management_additional_info',
        analyticsUploadSuccess: analyticsUploadSuccess,
        analyticsUploadFail: analyticsUploadFail,
        deleteEntity: deleteEntity}
    }).then(function (assetLib) {
      $log.info(angular.toJson({
        action: 'dialog closed successfully',
        functionName: functionName,
        assetLib: assetLib
      }));
    });

    $log.info(angular.toJson({action:'function return', functionName:functionName}));
  }

  function analyticsUploadSuccess(){

  }

  function analyticsUploadFail(){

  }

  function onAddAssetLib(addedEntry){
    addedEntry.statusForDisplay = $translate.instant("imposer.composer-main.Composer_Status_" + addedEntry.status);
  }

  function onAssetLibChange(changedEntry){
    changedEntry.statusForDisplay = $translate.instant("imposer.composer-main.Composer_Status_" + changedEntry.status);
  }

  $scope.$on('$destroy', function() {
    vm.listMonitoringUtility.close();
  });
}
